import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemIconLink } from 'record-it-components/cardList/CardListItemIconLink/CardListItemIconLink';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useTimeTrackingActivityCompilationDeleteHandler } from '../../../hooks/entity/deleteHandler/useTimeTrackingActivityCompilationDeleteHandler';
import { EditTimeTrackingActivityCompilationDialog } from '../EditTimeTrackingActivityCompilationDialog/EditTimeTrackingActivityCompilationDialog';
export type TimeTrackingActivityCompilationListItemProps = PropsWithoutChildren<CardListItemProps> & {
  timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
};
export const TimeTrackingActivityCompilationListItem: FunctionComponent<TimeTrackingActivityCompilationListItemProps> = React.memo(props => {
  const $ = _c(29);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let timeTrackingActivityCompilation;
  if ($[2] !== t0) {
    ({
      timeTrackingActivityCompilation,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = timeTrackingActivityCompilation;
  } else {
    remainingProps = $[3];
    timeTrackingActivityCompilation = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeOnBackDropClick: true
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened(t1);
  const handleDeleteClick = useTimeTrackingActivityCompilationDeleteHandler(timeTrackingActivityCompilation);
  let t2;
  if ($[6] !== timeTrackingActivityCompilation.name) {
    t2 = <CardListItemTitle data-testid="TimeTrackingActivityCompilationListItem.Title">{timeTrackingActivityCompilation.name}</CardListItemTitle>;
    $[6] = timeTrackingActivityCompilation.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== handleDeleteClick) {
    t3 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} data-testid="TimeTrackingActivityCompilationListItem.DeleteButton" />;
    $[8] = handleDeleteClick;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== openEditDialog) {
    t4 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.editInDialogIcon} onClick={openEditDialog} data-testid="TimeTrackingActivityCompilationListItem.EditButton" />;
    $[10] = openEditDialog;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== timeTrackingActivityCompilation.id) {
    t5 = RoutePaths.adminTimeTrackingActivities(timeTrackingActivityCompilation.id);
    $[12] = timeTrackingActivityCompilation.id;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <CardListItemIconLink {...iconConfigurations.prefixed.listItem.enterListItem} to={t5} />;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== remainingProps || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t6) {
    t7 = <CardListItem {...remainingProps}>{t2}{t3}{t4}{t6}</CardListItem>;
    $[16] = remainingProps;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== closeEditDialog || $[23] !== modalProps || $[24] !== timeTrackingActivityCompilation) {
    t8 = <EditTimeTrackingActivityCompilationDialog {...modalProps} timeTrackingActivityCompilation={timeTrackingActivityCompilation} onAccept={closeEditDialog} data-testid="TimeTrackingActivityCompilationListItem.EditDialog" />;
    $[22] = closeEditDialog;
    $[23] = modalProps;
    $[24] = timeTrackingActivityCompilation;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
});